export default __webpack_public_path__ + "static/media/Banner-Resenas-2-estimulos.2d7bd9f8.jpg";